/* eslint-disable camelcase */
import FuseUtils from '@fuse/utils/FuseUtils';
import { usuarioApi } from 'app/services/api/usuarioApi';
import { decrypt, encrypt, getEmpresaContexto } from 'app/utils/geralUtil';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import qs from 'query-string';
import financeiroApi from '../api/financeiroApi';

const ACCESS_TOKEN = 'AT';

const REFRESH_TOKEN = 'RT';

const EMPRESA_CONTEXTO = 'EC';

export const AUTHORITIES = {
  CATEGORIA_CADASTRAR: 'CATEGORIA_CADASTRAR',
  CATEGORIA_EDITAR: 'CATEGORIA_EDITAR',
  CATEGORIA_EXCLUIR: 'CATEGORIA_EXCLUIR',
  CATEGORIA_VISUALIZAR: 'CATEGORIA_VISUALIZAR',

  CLIENTE_CADASTRAR: 'CLIENTE_CADASTRAR',
  CLIENTE_EDITAR: 'CLIENTE_EDITAR',
  CLIENTE_EXCLUIR: 'CLIENTE_EXCLUIR',
  CLIENTE_VISUALIZAR: 'CLIENTE_VISUALIZAR',

  COMPRA_CADASTRAR: 'COMPRA_CADASTRAR',
  COMPRA_EDITAR: 'COMPRA_EDITAR',
  COMPRA_EXCLUIR: 'COMPRA_EXCLUIR',
  COMPRA_VISUALIZAR: 'COMPRA_VISUALIZAR',

  CONTA_VISUALIZAR: 'CONTA_VISUALIZAR',
  CONTA_CADASTRAR: 'CONTA_CADASTRAR',
  CONTA_EDITAR: 'CONTA_EDITAR',
  CONTA_EXCLUIR: 'CONTA_EXCLUIR',

  CONTAPAGAR_CADASTRAR: 'CONTAPAGAR_CADASTRAR',
  CONTAPAGAR_EDITAR: 'CONTAPAGAR_EDITAR',
  CONTAPAGAR_EXCLUIR: 'CONTAPAGAR_EXCLUIR',
  CONTAPAGAR_VISUALIZAR: 'CONTAPAGAR_VISUALIZAR',

  CONTARECEBER_CADASTRAR: 'CONTARECEBER_CADASTRAR',
  CONTARECEBER_EDITAR: 'CONTARECEBER_EDITAR',
  CONTARECEBER_EXCLUIR: 'CONTARECEBER_EXCLUIR',
  CONTARECEBER_VISUALIZAR: 'CONTARECEBER_VISUALIZAR',

  CONTRATO_CADASTRAR: 'CONTRATO_CADASTRAR',
  CONTRATO_EDITAR: 'CONTRATO_EDITAR',
  CONTRATO_EXCLUIR: 'CONTRATO_EXCLUIR',
  CONTRATO_VISUALIZAR: 'CONTRATO_VISUALIZAR',

  ESTOQUE_VISUALIZAR: 'ESTOQUE_VISUALIZAR',
  ESTOQUE_EDITAR: 'ESTOQUE_EDITAR',

  FORNECEDOR_CADASTRAR: 'FORNECEDOR_CADASTRAR',
  FORNECEDOR_EDITAR: 'FORNECEDOR_EDITAR',
  FORNECEDOR_EXCLUIR: 'FORNECEDOR_EXCLUIR',
  FORNECEDOR_VISUALIZAR: 'FORNECEDOR_VISUALIZAR',

  IMPOSTO_CADASTRAR: 'IMPOSTO_CADASTRAR',
  IMPOSTO_EDITAR: 'IMPOSTO_EDITAR',
  IMPOSTO_EXCLUIR: 'IMPOSTO_EXCLUIR',
  IMPOSTO_VISUALIZAR: 'IMPOSTO_VISUALIZAR',

  PERIODOFECHADO_CADASTRAR: 'PERIODOFECHADO_CADASTRAR',
  PERIODOFECHADO_EDITAR: 'PERIODOFECHADO_EDITAR',
  PERIODOFECHADO_EXCLUIR: 'PERIODOFECHADO_EXCLUIR',
  PERIODOFECHADO_VISUALIZAR: 'PERIODOFECHADO_VISUALIZAR',

  PRODUTO_CADASTRAR: 'PRODUTO_CADASTRAR',
  PRODUTO_EDITAR: 'PRODUTO_EDITAR',
  PRODUTO_EXCLUIR: 'PRODUTO_EXCLUIR',
  PRODUTO_VISUALIZAR: 'PRODUTO_VISUALIZAR',

  SERVICO_CADASTRAR: 'SERVICO_CADASTRAR',
  SERVICO_EDITAR: 'SERVICO_EDITAR',
  SERVICO_EXCLUIR: 'SERVICO_EXCLUIR',
  SERVICO_VISUALIZAR: 'SERVICO_VISUALIZAR',

  TRANSPORTADORA_CADASTRAR: 'TRANSPORTADORA_CADASTRAR',
  TRANSPORTADORA_EDITAR: 'TRANSPORTADORA_EDITAR',
  TRANSPORTADORA_EXCLUIR: 'TRANSPORTADORA_EXCLUIR',
  TRANSPORTADORA_VISUALIZAR: 'TRANSPORTADORA_VISUALIZAR',

  VENDEDOR_CADASTRAR: 'VENDEDOR_CADASTRAR',
  VENDEDOR_EDITAR: 'VENDEDOR_EDITAR',
  VENDEDOR_EXCLUIR: 'VENDEDOR_EXCLUIR',
  VENDEDOR_VISUALIZAR: 'VENDEDOR_VISUALIZAR',

  USUARIO_VISUALIZAR: 'USUARIO_VISUALIZAR',
  USUARIO_CADASTRAR: 'USUARIO_CADASTRAR',
  USUARIO_EDITAR: 'USUARIO_EDITAR',
  USUARIO_EXCLUIR: 'USUARIO_EXCLUIR',

  PARAMETRO_VISUALIZAR: 'PARAMETRO_VISUALIZAR',
  PARAMETRO_CADASTRAR: 'PARAMETRO_CADASTRAR',
  PARAMETRO_EDITAR: 'PARAMETRO_EDITAR',
  PARAMETRO_EXCLUIR: 'PARAMETRO_EXCLUIR',

  GRUPOACESSO_VISUALIZAR: 'GRUPOACESSO_VISUALIZAR',
  GRUPOACESSO_CADASTRAR: 'GRUPOACESSO_CADASTRAR',
  GRUPOACESSO_EDITAR: 'GRUPOACESSO_EDITAR',
  GRUPOACESSO_EXCLUIR: 'GRUPOACESSO_EXCLUIR',

  VENDA_CADASTRAR: 'VENDA_CADASTRAR',
  VENDA_EDITAR: 'VENDA_EDITAR',
  VENDA_EXCLUIR: 'VENDA_EXCLUIR',
  VENDA_VISUALIZAR: 'VENDA_VISUALIZAR',

  ORDEMSERVICO_VISUALIZAR: 'ORDEMSERVICO_VISUALIZAR',
  ORDEMSERVICO_CADASTRAR: 'ORDEMSERVICO_CADASTRAR',
  ORDEMSERVICO_EDITAR: 'ORDEMSERVICO_EDITAR',
  ORDEMSERVICO_EXCLUIR: 'ORDEMSERVICO_EXCLUIR',

  RELATORIO_DRE_VISUALIZAR: 'RELATORIO_DRE_VISUALIZAR',
  RELATORIO_DESPESA_VISUALIZAR: 'RELATORIO_DESPESA_VISUALIZAR',
  RELATORIO_RECEITA_VISUALIZAR: 'RELATORIO_RECEITA_VISUALIZAR',
  RELATORIO_FLUXOCAIXA_VISUALIZAR: 'RELATORIO_FLUXOCAIXA_VISUALIZAR',
  RELATORIO_BALANCETE_VISUALIZAR: 'RELATORIO_BALANCETE_VISUALIZAR',
  REL_VENDA_VISUALIZAR: 'REL_VENDA_VISUALIZAR',
  RELATORIO_CC_VISUALIZAR: 'RELATORIO_CC_VISUALIZAR',
  REL_CLIENTE_VISUALIZAR: 'REL_CLIENTE_VISUALIZAR',
  REL_CONTRATO_VISUALIZAR: 'REL_CONTRATO_VISUALIZAR',
  REL_RECEITA_CLIENTE_VISUALIZAR: 'REL_RECEITA_CLIENTE_VISUALIZAR',
  REL_DESPESA_FORNECEDOR_VISUALIZAR: 'REL_DESPESA_FORNECEDOR_VISUALIZAR',
  REL_CERTIDAO_NEGATIVA_VISUALIZAR: 'REL_CERTIDAO_NEGATIVA_VISUALIZAR',

  NOTAS_FISCAIS_VISUALIZAR: 'NOTAS_FISCAIS_VISUALIZAR',

  TRANSFERENCIA_VISUALIZAR: 'TRANSFERENCIA_VISUALIZAR',
  TRANSFERENCIA_CADASTRAR: 'TRANSFERENCIA_CADASTRAR',
  TRANSFERENCIA_EDITAR: 'TRANSFERENCIA_EDITAR',
  TRANSFERENCIA_EXCLUIR: 'TRANSFERENCIA_EXCLUIR',

  CONCILIACAO_VISUALIZAR: 'CONCILIACAO_VISUALIZAR',
  CONCILIACAO_CADASTRAR: 'CONCILIACAO_CADASTRAR',
  CONCILIACAO_EDITAR: 'CONCILIACAO_EDITAR',
  CONCILIACAO_EXCLUIR: 'CONCILIACAO_EXCLUIR',

  MINHAEMPRESA_VISUALIZAR: 'MINHAEMPRESA_VISUALIZAR',
  MINHAEMPRESA_EDITAR: 'MINHAEMPRESA_EDITAR',
  MINHAEMPRESA_CADASTRAR: 'MINHAEMPRESA_CADASTRAR',

  CENTRO_CUSTO_CADASTRAR: 'CENTRO_CUSTO_CADASTRAR',
  CENTRO_CUSTO_EDITAR: 'CENTRO_CUSTO_EDITAR',
  CENTRO_CUSTO_EXCLUIR: 'CENTRO_CUSTO_EXCLUIR',
  CENTRO_CUSTO_VISUALIZAR: 'CENTRO_CUSTO_VISUALIZAR',

  INTEGRACAO_CONTABIL_VISUALIZAR: 'INTEGRACAO_CONTABIL_VISUALIZAR',
  INTEGRACAO_CONTABIL_EDITAR: 'INTEGRACAO_CONTABIL_EDITAR',

  CONFIGURAR_RC_VISUALIZAR: 'CONFIGURAR_RC_VISUALIZAR',
  CONFIGURAR_RC_CADASTRAR: 'CONFIGURAR_RC_CADASTRAR',
  CONFIGURAR_RC_EDITAR: 'CONFIGURAR_RC_EDITAR',
  CONFIGURAR_RC_EXCLUIR: 'CONFIGURAR_RC_EXCLUIR',

  ACOMPANHAR_RC_VISUALIZAR: 'ACOMPANHAR_RC_VISUALIZAR',

  GESTAO_ENVIO_VISUALIZAR: 'GESTAO_ENVIO_VISUALIZAR',

  DASHBOARD_VISUALIZAR: 'DASHBOARD_VISUALIZAR',
};

class AuthService extends FuseUtils.EventEmitter {
  init(success) {
    this.setInterceptors();
    this.handleAuthentication();
    success(true);
  }

  setInterceptors = () => {
    axios.interceptors.request.use(
      function(config) {
        // Do something before request is sent
        config.headers.realm = 'financeiro';

        return config;
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise(() => {
          if (err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
            // if you ever get an unauthorized response, logout the user
            this.emit('onAutoLogout', 'Invalid access token');
            this.setSession(null, null);
          }
          throw err;
        });
      }
    );
    financeiroApi.interceptors.request.use(async (config) => {
      // const TIMEOUT = 120000;
      const authService = instance;

      try {
        if (
          !authService.isAuthTokenValid(authService.getAccessToken()) &&
          authService.isAuthTokenValid(authService.getRefreshToken())
        ) {
          const { accessToken } = await authService.signInWithToken();

          config.headers.Authorization = `Bearer ${accessToken}`;
        }

        config.headers.empresaId = getEmpresaContexto();
        config.headers.origem = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
      } catch (err) {
        console.error(err);
      }

      // config.timeout = TIMEOUT;
      // config.headers['X-TenantID'] = 'public';
      return config;
    });
  };

  handleAuthentication = () => {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      this.emit('onNoAccessToken');

      return;
    }

    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      this.emit('onNoRefreshToken');

      return;
    }

    if (this.isAuthTokenValid(refreshToken)) {
      this.setSession(accessToken, refreshToken);
      this.emit('onAutoLogin', true);
    } else {
      this.setSession(null, null);
      this.emit('onAutoLogout', 'refreshToken expired');
    }
  };

  createUser = (data) => {
    return new Promise((resolve, reject) => {
      axios.post('/api/auth/register', data).then((response) => {
        if (response.data.user) {
          this.setSession(response.data.accessToken);
          resolve(response.data.user);
        } else {
          reject(response.data.error);
        }
      });
    });
  };

  signInWithEmailAndPassword = (email, password) => {
    return new Promise((resolve, reject) => {
      const requestUrl = `${process.env.REACT_APP_GANDALF}/api/v1/gandalf/auth`;

      const credentials = { login: email, senha: password, clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID };

      axios
        .post(requestUrl, credentials)
        .then((response) => {
          if (response.data.access_token) {
            this.setSession(response.data.access_token, response.data.refresh_token);

            const decodedToken = jwtDecode(response.data.access_token);

            resolve(decodedToken);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          // this.logout();
          reject(error);
        });
    });
  };

  signInWithToken = () => {
    const refreshToken = this.getRefreshToken();

    return new Promise((resolve, reject) => {
      const requestUrl = `${process.env.REACT_APP_KEYCLOAK_URL}realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`;

      const credenciais = qs.stringify({
        refresh_token: refreshToken,
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        grant_type: 'refresh_token',
      });

      fetch(requestUrl, {
        method: 'POST',
        body: credenciais,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.access_token) {
            this.setSession(response.access_token, response.refresh_token);

            const decodedToken = jwtDecode(response.access_token);

            resolve({ decodedToken, accessToken: response.access_token });
          } else {
            // this.logout();
            reject(new Error('Failed to login with token.'));
            // Promise.reject(new Error('Failed to login with token.'));
          }
        })
        .catch((error) => {
          // this.logout();
          reject(error);
        });
    });
  };

  updateUserData = (user) => {
    return usuarioApi.updateAtalhos(user);
  };

  setSession = (accessToken, refreshToken, idToken) => {
    if (accessToken) {
      const accessTokenEncrypted = encrypt(accessToken);

      localStorage.setItem(ACCESS_TOKEN, accessTokenEncrypted);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      financeiroApi.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem(ACCESS_TOKEN);
      delete axios.defaults.headers.common.Authorization;
      delete financeiroApi.defaults.headers.common.Authorization;
    }

    if (refreshToken) {
      const refreshTokenEncrypted = encrypt(refreshToken);

      localStorage.setItem(REFRESH_TOKEN, refreshTokenEncrypted);
    } else {
      localStorage.removeItem(REFRESH_TOKEN);
    }

    if (idToken) {
      const idTokenEncrypted = encrypt(idToken);
      localStorage.setItem('IDT', idTokenEncrypted);
    }
  };

  logout = () => {
    this.setSession(null, null);
    localStorage.removeItem(EMPRESA_CONTEXTO);
    localStorage.clear();
  };

  /**
   * Verifica se o AccessToken tem a vida util de 24 horas
   * @param {*} jwt
   * @returns
   */
  isAuthTokenLess24Hours = (jwt) => {
    if (!jwt) {
      return false;
    }

    try {
      const decoded = jwtDecode(jwt);
      const now = moment();
      const { exp } = decoded;
      const expToken = moment(exp * 1000);
      const hoursDiff = moment.duration(expToken.diff(now)).asHours();

      if (hoursDiff > 0) {
        return true;
      }

      return false;
    } catch (err) {
      return false;
    }
  };

  isAuthTokenValid = (jwt) => {
    if (!jwt) {
      return false;
    }
    try {
      const decoded = jwtDecode(jwt);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        console.warn('jwt expired');
        return false;
      }

      return true;
    } catch (err) {
      return false;
    }
  };

  getAccessToken = () => {
    const accessTokenEncrypted = window.localStorage.getItem(ACCESS_TOKEN);

    if (accessTokenEncrypted) {
      return decrypt(accessTokenEncrypted);
    }

    return null;
  };

  getDecodedAccessToken = () => {
    const token = this.getAccessToken();
    return jwtDecode(token);
  };

  getRefreshToken = () => {
    const refreshTokenEncrypted = window.localStorage.getItem(REFRESH_TOKEN);

    if (refreshTokenEncrypted) {
      return decrypt(refreshTokenEncrypted);
    }

    return null;
  };

  hasAuthority = (authorities) => {
    try {
      const _authorities = authorities instanceof Array ? authorities : [authorities];

      const decodedToken = this.getDecodedAccessToken();

      return _authorities.some((authority) => decodedToken?.realm_access?.roles?.includes(authority));
    } catch (err) {
      console.error(err);
    }
    return false;
  };
}

const instance = new AuthService();

export default instance;
